import React, { useState, useEffect, useCallback, useRef } from "react";
import { Table, Pagination, Select } from "antd";
// import { cloneDeep, get, map , filter} from "lodash";
import { CaretDownOutlined } from "@ant-design/icons";
import classNames from "classnames";
import "./table.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { find, isEmpty, map, noop , isFunction} from "lodash";
import { ClearFilters, ColFilters, FilterIcon, SortHeader, formatFilterDataForApi, getDropdownFilters } from "@components/filters/colFilters";
import { useDurableStore } from "@stores/useDurableStore";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import { useDropdowns } from "@utils/customHooks";

const { Option } = Select;

const rowsPerPageArray: any[] = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

type TableProps = {
  condition?: boolean | undefined;
  dependencyProps?: any;
  handleFetchData: any;
  className: any;
  columns: any;
  rowSelectionNeeded?: boolean | undefined;
  loading?: boolean;
  perPageCount?: number;
  columnOriginalList?: any;
  dependencyPropsForPage1?: any;
  scrollProp?: any;
  message ?: string;
  filteredInfo : any;
  setFilteredInfo : any
  reportName?: string
};

const TableWithDynamicPagination = ({
  perPageCount = 5,
  loading = false,
  condition = true,
  dependencyProps = [],
  handleFetchData,
  className,
  columns,
  rowSelectionNeeded = false,
  columnOriginalList,
  dependencyPropsForPage1,
  scrollProp = undefined,
  message = '',
  filteredInfo = {},
  setFilteredInfo = noop,
  reportName,
}: TableProps) => {
  // Local States for table
  const [isLoading, setLoading] = useState(false);
  const tableParams = useGenericTableStore((state) => state.tableParams);
  const setTableParams = useGenericTableStore((state) => state.setTableParams);
  const filterDropdowns = useDurableStore((state) => state.filterDropdowns);
  const data = useGenericTableStore((state) => state.data);
  const setData = useGenericTableStore((state) => state.setData);
  const showFilters = useGenericTableStore((state) => state.showFilters);
  const [rowsPerPageToggle, setRowsPerPageToggle] = useState<boolean>(false);
  const {getOptions} = useDropdowns();

  // refs
  const inputref = useRef<any>(null);

  // useEffect(() => {
  //   setTableParams({
  //     pagination: {
  //       current: 1,
  //       pageSize: perPageCount ? perPageCount : 5,
  //     },
  //   })
  // },[])

  // useEffect to fetch the drop downs related to column filters
  useEffect(() => {
    console.log("TableWithDynamicPagination, usEffect");
    getOptions(getDropdownFilters({ colData: columnOriginalList }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnOriginalList]);

  function handleTableChange(pagination: any, filters: any = tableParams.filters, sorter: any = tableParams.sorter){
    console.log("TableWithDynamicPagination.handleTableChange", pagination);
    setTableParams({
      pagination: {
        ...tableParams?.pagination,
        ...pagination,
        current: 1,
      },
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    // if (pagination.pageSize !== tableParams.pagination?.pageSize) {
    //   setData([]);
    // }
  };

  // columns with column filters
  let newColumns = map(columns, (item) => {
    if (find(columnOriginalList, { dataIndex: item.dataIndex })?.type) {
      return {
        ...item,
        title: <SortHeader item={item} pageName={dependencyProps[0]} handleData={(sorter: any) => handleTableChange({}, undefined, sorter)} />,
        filterDropdown: ({ confirm, visible }: any) => {
          return (
            <ColFilters
              item={find(columnOriginalList, { dataIndex: item.dataIndex })}
              inputref={inputref}
              confirm={confirm}
              visible={visible}
              getTableData={(filters: any) => {
                setTableParams({
                  ...tableParams,
                  pagination: {
                    ...tableParams?.pagination,
                    current: 1,
                  },
                });
              }}
              filteredInfo={filteredInfo}
              setFilteredInfo={setFilteredInfo}
              // resetFilterPage={resetFilterPage}
              filterDropdowns={filterDropdowns}
              columns={columnOriginalList}
            />
          );
        },
        filterIcon: () => <FilterIcon filteredInfo={filteredInfo} item={find(columnOriginalList, { dataIndex: item.dataIndex })} />,
        onFilter: (value: any, record: any) => (record[item.dataIndex] ? record[item.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ""),
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => {
              if (inputref.current && isFunction(inputref.current?.select)) {
                inputref.current.select();
              }
            }, 100);
          }
        },
      };
    } else {
      return {
        ...item,
      };
    }
  });

  // fetch Data for the table
  const fetchData = useCallback(async () => {
    console.log("TableWithDynamicPagination, fetchData", dependencyPropsForPage1);
    
    if (condition) {
      setLoading(true);
  
      const calcPageNo = !isEmpty(dependencyPropsForPage1) && previousState !== dependencyPropsForPage1 ? 1 : tableParams?.pagination?.current;
  
      try {
        const _data = await handleFetchData({
          pageNo: calcPageNo ? calcPageNo - 1 : 0,
          pageSize: tableParams?.pagination?.pageSize,
          sortBy: tableParams?.columnKey,
          sortType: tableParams?.order === "ascend" ? "ASC" : tableParams?.order === "descend" ? "DESC" : tableParams?.order,
          filters: formatFilterDataForApi(filteredInfo),
        });
  
        setData(_data?.data);
        setLoading(false);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: _data?.totalCount,
            current: calcPageNo,
          },
        });
  
      } catch (error) {
        setLoading(false);
      }
    }
  }, [tableParams?.pagination?.current, dependencyPropsForPage1, tableParams?.pagination?.pageSize, tableParams?.columnKey, tableParams?.order, filteredInfo, ...dependencyProps]);
  


  useEffect(() => {
    console.log("TableWithDynamicPagination.useEffect2");
    fetchData();
  }, [fetchData]);

  const handlePageChange = (newPage: any) => {
    console.log("TableWithDynamicPagination, handlePageChange");
    if(!isLoading) {
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams?.pagination,
          current: newPage,
        },
      });
    }
  };

  const tableClassNames = classNames("ui-new-generic-table", className);

  const usePrevious = (value: { receiveAmount: any; sendAmount: any } | undefined) => {
    console.log("TableWithDynamicPagination, usePrevious");
    const ref: any = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const previousState = usePrevious(dependencyPropsForPage1);

  // useEffect(() => {
  //   console.log("TableWithDynamicPagination, useEffect3")
  //   if (!isEmpty(dependencyPropsForPage1)) {
  //     if (previousState !== dependencyPropsForPage1 && tableParams?.pagination?.current !== 1) {
  //       setTableParams({
  //         ...tableParams,
  //         pagination: {
  //           ...tableParams?.pagination,
  //           current: 1,
  //         },
  //       });
  //     } else if (previousState !== dependencyPropsForPage1 && tableParams?.pagination?.current === 1) {

  //       fetchData();
  //     }
  //   }
  // }, [dependencyPropsForPage1]);

  return (
    <>
      <ClearFilters filteredInfo={filteredInfo} setFilteredInfo={setFilteredInfo} getFilteredTableData={noop} showFilters={showFilters} />
      <Table
        className={tableClassNames}
        showSorterTooltip={{
          placement: "bottom",
          title: "Click to change sort order",
        }}
        columns={newColumns}
        dataSource={[...(data || [])]}
        rowSelection={rowSelectionNeeded ? {} : undefined}
        pagination={false}
        bordered
        loading={{ spinning: isLoading || loading, indicator: <HealthemSpinner /> }}
        onChange={handleTableChange}
        id="member-table"
        scroll={scrollProp ? scrollProp : { y: window.innerHeight - 360 }}
      />
      {data?.length > 0 && (
        <div className={`pagination ui-table-pagination ${isLoading ? 'disabled' : ''}`}>
          <div>
            Show
            <Select
              defaultValue={tableParams?.pagination?.pageSize}
              style={{ width: 64, margin: "8px 8px" }}
              onChange={(e) => handleTableChange({ ...tableParams?.pagination, pageSize: e })}
              suffixIcon={<CaretDownOutlined />}
              onClick={() => setRowsPerPageToggle(!rowsPerPageToggle)}
              open={rowsPerPageToggle}
            >
              {rowsPerPageArray.map((val) => (
                <Option key={val} value={val}>
                  {val}
                </Option>
              ))}
            </Select>
            rows per page
          </div>
          {data?.length > 0 && (
            <Pagination
              total={tableParams?.pagination?.total}
              showTotal={(total: any, range: any) => (
                <>
                  <span style={{ color: "#091e42" }}>
                    {tableParams?.pagination?.pageSize * tableParams?.pagination?.current - (tableParams?.pagination?.pageSize - 1)} -{" "}
                    {tableParams?.pagination?.pageSize * tableParams?.pagination?.current > data?.length
                      ? data?.length + tableParams?.pagination?.pageSize * tableParams?.pagination?.current - (tableParams?.pagination?.pageSize - 1) - 1
                      : tableParams?.pagination?.pageSize * tableParams?.pagination?.current +
                        tableParams?.pagination?.pageSize * tableParams?.pagination?.current -
                        (tableParams?.pagination?.pageSize - 1) -
                        1}
                  </span>
                  <span> of {tableParams?.pagination?.total}</span>
                </>
              )}
              key={tableParams?.pagination?.pageSize}
              defaultPageSize={tableParams?.pagination?.pageSize}
              defaultCurrent={tableParams?.pagination?.current}
              current={tableParams?.pagination?.current}
              showSizeChanger={false}
              onChange={(e: any) => {
                handlePageChange(e);
              }}
            />
          )}
        </div>
      )}
      <div className="ui-new-generic-table__message mt-05">
        <span>{message}</span>
        {reportName === "HCC-GAP-REPORT" && <span>Note: Data displayed is from the last 24 months</span>}
      </div>
    </>
  );
};

export default TableWithDynamicPagination;
